/**
 * Which app this build is (DukaanBook-Design.docx, section 2): DukaanBook when
 * started with `--mode dukaanbook` (`pnpm dukaan:web`), FarmashiBook otherwise.
 * Known at build time.
 */
export const IS_DUKAANBOOK = import.meta.env.MODE === "dukaanbook";

/** The app's privacy policy on the company website (guide 5.6; DukaanBook-Design.docx, section 8). */
export const PRIVACY_URL = IS_DUKAANBOOK
  ? "https://ileyktechnologies.com/dukaan/privacy/"
  : "https://ileyktechnologies.com/pharmacy/privacy/";

/**
 * The app's mark beside its name. FarmashiBook's icon; DukaanBook's is the
 * open book whose pages are two shop fronts (decision D1: draft C, chosen by
 * the owner on 2026-10-26), drawn in public/dukaanbook/.
 */
export function BrandMark({ size, className }: { size: number; className?: string }) {
  const src = IS_DUKAANBOOK ? "/dukaanbook/icon-square.svg" : "/icon-192.png";
  return <img src={src} alt="" width={size} height={size} className={className} />;
}
